import { render } from "./list_of_rooms.vue?vue&type=template&id=0d9487bc&scoped=true"
import script from "./list_of_rooms.vue?vue&type=script&lang=js"
export * from "./list_of_rooms.vue?vue&type=script&lang=js"

import "./list_of_rooms.vue?vue&type=style&index=0&id=0d9487bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9487bc"]])

export default __exports__